import { useEffect, useState } from "react";
import { ENV } from "@/config/environment";

export function useAppVersion() {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch("/version.json", { cache: "no-store" });
        if (!res.ok) return;
        const remote = (await res.json()) as { hash: string };
        if (remote.hash && remote.hash !== ENV.buildHash) setOutdated(true);
      } catch {
        /* offline */
      }
    };
    check();
    const id = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return outdated;
}
